export default __webpack_public_path__ + "static/media/icon-telefon.3f13c454.svg";